<template>
  <NuxtLayout
    :is-menu-hidden="page?.is_menu_hidden"
    :is-footer-hidden="page?.is_footer_hidden"
  >
    <div>
      <Breadcrumbs v-if="page?.course?.slug" :links="breadcrumbs" />
      <CourseDateCover v-if="page?.course" :page="page" />
      <Widgets v-if="page?.widgets" :widgets="page?.widgets" without-h1 />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const route = useRoute()

const slug = flatten(route.params.slug)
const date = flatten(route.params.date)
const fullSlug = `${slug}/${date}`

const { data: page, error } = await useAsyncData(
  `course-${slug}-${date}`,
  async () => useApi().publicPagesCourseAndEventsDatesRetrieve(date)
)

const title = computed(() =>
  page.value
    ? `${page.value?.city}, ${getCourseDate(
        page.value?.start_date,
        page.value?.end_date
      )}`
    : ''
)

const breadcrumbs = computed(() => [
  {
    title: page.value?.course?.title ?? '',
    to: { name: 'course-slug', params: { slug: page.value?.course?.slug } }
  },
  {
    title: title.value
  }
])

if (error.value || page.value?.full_slug !== fullSlug) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    'pl-pl': '/kurs/[slug]/[date]'
  }
})

const setI18nParams = useSetI18nParams()
setI18nParams({
  'pl-pl': {
    slug: page.value?.course?.slug_pl,
    date: page.value?.slug_pl
  },
  'pl-en': {
    slug: page.value?.course?.slug_en,
    date: page?.value?.slug_en
  }
})

const { meta } = usePrepareSEOHead(page)
useHead({
  title,
  meta
})
</script>
